/**
 * @module ScenesReducer
 *
 * @desc Reducer for scenes
 */

import { SET_SCENES, UPDATE_SCENE_BY_ID } from './types';
import { createSelector } from '@reduxjs/toolkit';

const initialState = {};

const scenesReducer = (state = initialState, action = {}) => {
	const { type, payload } = action;
	switch (type) {
		case SET_SCENES: {
			const newScenes = payload.reduce((acc, curr) => {
				acc[curr.id] = curr;
				return acc;
			}, {});
			return {
				...state,
				...newScenes,
			};
		}
		case UPDATE_SCENE_BY_ID: {
			const { id, ...rest } = payload;
			return {
				...state,
				[id]: {
					...state[id],
					...rest,
				},
			};
		}
		default:
			return state;
	}
};

export const getSceneIdToNamesMap = createSelector(
	(state) => state.scenes,
	(scenes) => {
		return Object.keys(scenes).reduce((acc, key) => {
			acc[key] = scenes[key].name;
			return acc;
		}, {});
	},
);

export default scenesReducer;
